import { axiosPartnerInstance } from "../helpers/axiosInstance";
import { AppCache } from "../helpers/myStorage";

export const buyApprovesList = (resellerId, owner = null) => {
  if (!resellerId) {
    throw new Error("resellerId parametresi zorunludur.");
  }

  const params = { resellerId };
  if (owner) {
    params.owner = owner;
  }

  return axiosPartnerInstance.get("/admin/licenseToBeApprovedList", {
    params
  });
};

export const specialCaseRecord = (note, partnerSalesId, salesList) => {
  const data = { note, partnerSalesId, salesList };

  return axiosPartnerInstance.post("/admin/specialCaseRecord", data);
};


export const unSuspendBuyApprove = (Id) => {
  return axiosPartnerInstance.post("/Admin/unsuspendBuyApprove", { Id, uuid: "" });
};

const buyApproveService = {
  buyApprovesList,
  unSuspendBuyApprove
}

export default buyApproveService;